/**
 * Behavior for gallery slice
 */
(function (Drupal, $, once) {
  Drupal.behaviors.rmccGallerySLice = {
    attach(context, settings) {
      once('rmccGallerySLiceBehavior', '.gallery-slice', context).forEach((elem, i) => {

        let $sliderFor = $('.gallery-slice__slider--for', $(elem)),
            $sliderNav = $('.gallery-slice__slider--nav', $(elem));

        $sliderFor.addClass('slider-for-' + i);
        $sliderNav.addClass('slider-nav-' + i);

        $sliderFor.slick({
          slidesToShow:   1,
          slidesToScroll: 1,
          arrows:         false,
          fade:           true,
          asNavFor:       '.slider-nav-' + i,
          adaptiveHeight: false
        });

        $sliderNav.slick({
          slidesToScroll: 0,
          asNavFor:       '.slider-for-' + i,
          dots:           false,
          focusOnSelect:  true,
          centerMode:     true,
          variableWidth:  true
        });

      });
    }
  };
}) (Drupal, jQuery, once);